"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnnouncements = void 0;

var _loudspeakerclient = require("../clients/loudspeakerclient");

var _customizrclient = require("../clients/customizrclient");

var _react = require("react");

const useAnnouncements = (accessToken, channelIds, env) => {
  const [data, setData] = (0, _react.useState)({
    isVisible: false,
    remoteAnnouncements: []
  });
  const strChannelsIds = JSON.stringify(channelIds);
  (0, _react.useEffect)(() => {
    const f = async () => {
      if (accessToken && channelIds) {
        const loudspeakerClient = new _loudspeakerclient.LoudspeakerClient({
          accessToken: accessToken,
          channelIds: channelIds
        }, env);
        const customizrClient = new _customizrclient.CustomizrClient();
        const timestampsByChannelId = await customizrClient.getLastAcknowledgementTimestamps(accessToken);
        const remoteAnnouncements = await loudspeakerClient.getAnnouncements({
          after: timestampsByChannelId
        });
        setData({
          isVisible: remoteAnnouncements.length > 0,
          remoteAnnouncements: remoteAnnouncements
        });
      }
    };

    f();
  }, [accessToken, strChannelsIds]);
  return {
    isVisible: data.isVisible,
    remoteAnnouncements: data.remoteAnnouncements
  };
};

exports.useAnnouncements = useAnnouncements;